import Card from "components/card";
import Loader from "components/loader";
import useStats from "hooks/useStats";
import { useEffect, useMemo, useState } from "react";
import Chart from "react-apexcharts";
import { DASHBOARD_COLORS } from "utils/dashboardColors";

const MESES_ABREV = [
  "Ene", "Feb", "Mar", "Abr", "May", "Jun",
  "Jul", "Ago", "Sep", "Oct", "Nov", "Dic",
];

const LAST_N_MONTHS = 12;

const formatMonthLabel = (mes) => {
  const [year, month] = String(mes).split("-").map(Number);
  if (!year || !month) return mes;
  return `${MESES_ABREV[month - 1]} ${String(year).slice(-2)}`;
};

const NewRegistrationsChart = () => {
  const { isLoading, fetchData } = useStats("resumen-usuarios-mensual");
  const [mensual, setMensual] = useState([]);

  const fetchMensual = async () => {
    const response = await fetchData();
    const payload = response?.resumen_actual ? response : response?.data || {};
    const rows = Array.isArray(payload?.mensual) ? payload.mensual : [];
    setMensual(rows);
  };

  useEffect(() => {
    fetchMensual();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const ultimosMeses = useMemo(() => {
    return [...mensual]
      .filter((item) => item?.mes)
      .sort((a, b) => (a.mes > b.mes ? 1 : -1))
      .slice(-LAST_N_MONTHS);
  }, [mensual]);

  const chartSeries = useMemo(
    () => [
      { name: "Postulantes nuevos", data: ultimosMeses.map((item) => Number(item?.postulantes_nuevos || 0)) },
      { name: "Instituciones nuevas", data: ultimosMeses.map((item) => Number(item?.instituciones_nuevas || 0)) },
    ],
    [ultimosMeses]
  );

  const chartOptions = useMemo(
    () => ({
      chart: {
        type: "bar",
        toolbar: { show: false },
        stacked: false,
      },
      plotOptions: {
        bar: {
          columnWidth: "55%",
          borderRadius: 4,
        },
      },
      colors: [DASHBOARD_COLORS.postulantes, DASHBOARD_COLORS.instituciones],
      dataLabels: { enabled: false },
      xaxis: {
        categories: ultimosMeses.map((item) => formatMonthLabel(item.mes)),
        labels: { style: { colors: "#A3AED0", fontSize: "12px" } },
      },
      yaxis: {
        labels: { style: { colors: "#A3AED0", fontSize: "12px" } },
      },
      legend: { show: true, position: "top" },
      grid: { show: false },
      tooltip: { theme: "dark" },
    }),
    [ultimosMeses]
  );

  return (
    <Card extra="!p-[20px] h-[500px]">
      <div className="text-xl font-bold text-navy-700 dark:text-white mb-2">
        Nuevos registros por mes
      </div>

      <div className="h-[420px] w-full">
        {isLoading ? (
          <Loader />
        ) : ultimosMeses.length === 0 ? (
          <p className="text-sm text-gray-600">No hay datos disponibles</p>
        ) : (
          <Chart options={chartOptions} series={chartSeries} type="bar" width="100%" height="100%" />
        )}
      </div>
    </Card>
  );
};

export default NewRegistrationsChart;
